import { required, optional, obj, array } from 'AppReact/schema';

export default {
    welcome_popup_enable: optional('boolean'),
    isOpen: required('boolean'),
    name: optional('string'),
    title: optional('string'),
    username: optional('string'),
    email: optional('string'),
    password: optional('string'),
    superAdmin: optional('boolean'),
    selectedPropertyIds: array('integer'),
    selectedRoleIds: array('integer'),
    nameError: optional('string'),
    usernameError: optional('string'),
    emailError: optional('string'),
    passwordError: optional('string'),
    phoneNumber: optional('string'),
}
